import { useQuery } from 'react-query'
import { NestAPI, useGetBusiness } from '@marketing-milk/frontend'
import { CreativeImportActiveJob } from '@marketing-milk/interfaces'

/**
 * The business's currently running import, if any — powers the warn-but-allow
 * banner on the Upload step. Null when nothing is queued/processing.
 */
export const useCreativeImportActive = (enabled: boolean) => {
  const business = useGetBusiness()

  return useQuery<CreativeImportActiveJob | null>(
    ['creative-import-active', business.id],
    async () => {
      const response = await NestAPI.get<CreativeImportActiveJob | null>(
        `businesses/${business.id}/creative-import/active`
      )
      // Axios turns an empty 200 body into '' — normalize to null.
      return response.data || null
    },
    { enabled }
  )
}
